import React, { useEffect, useState } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Loader from '../../../Components/Utility/Loader/Loader';
import * as submitAction from './Store/Submit.action';
import MultiSubmitLogCard from './SubmitDownloadLogs/MultiSubmitLogCard';

function MultiDownloadLogs() {
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const queryParams = new URLSearchParams(location.search);
  const reqId = queryParams.get('reqId') ? queryParams.get('reqId') : '';
  const autoDownload = queryParams.get('autoDownload') ? queryParams.get('autoDownload') : false;

  const [state, setState] = useState({
    submitLogdata: [],
    loading: true,
    backButtonShow: true,
    userEmail: '',
  });
  const { submitLogdata, loading, backButtonShow } = state;

  const getMultiSubmissionLogList = async (params) => {
    setState((prev) => ({
      ...prev,
      loading: true,
    }));
    const myLogs = await submitAction.getMultiDownloadLogs(params);
    setState((prev) => ({
      ...prev,
      loading: false,
    }));
    if (myLogs) {
      setState((prev) => ({
        ...prev,
        submitLogdata: myLogs,
      }));
    }
  };

  const checkIfUserLoggedIn = async () => {
    const user = JSON.parse(localStorage.getItem('loggedInUserInfo'));
    if ((user?.mfaEnabled && user?.mfaVerified) || user?.masterPasswordMatched) {
      setState((prev) => ({
        ...prev,
        userEmail: user?.email,
      }));
      const params = {
        email: user?.email,
        formail: true,
      };
      const accessRes = await submitAction.requestForDownload(params);
      if (accessRes) {
        const fetchParams = {
          email: encodeURIComponent(user?.email),
          reqId,
        };
        getMultiSubmissionLogList(fetchParams);
      }
      return true;
    }

    const callbackUrl = encodeURIComponent(window.location.href);
    window.location.href = `/login?callback=${callbackUrl}`;
    return false;
  };

  useEffect(() => {
    const init = async () => {
      checkIfUserLoggedIn();
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const downloadFile = async (item) => {
    await submitAction.multipleDownload(item, timeZone);
  };
  useEffect(() => {
    // Auto-download if reqId matches any item
    if (reqId && submitLogdata.length > 0) {
      const parentElementToDownload = submitLogdata?.find((subArray) => {
        return subArray?.some((item) => item?.reqId === reqId);
      });
      if (parentElementToDownload?.length && autoDownload === 'true') {
        downloadFile(parentElementToDownload);
        const { pathname, search } = history.location;
        const searchParams = new URLSearchParams(search);
        searchParams.delete('autoDownload'); // Remove autoDownload parameter
        const newSearch = searchParams.toString();
        const newUrl = newSearch ? `${pathname}?${newSearch}` : pathname; // Create new URL without autoDownload parameter
        history.replace(newUrl); // Replace the current URL
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitLogdata.length, reqId]);

  const deleteFiles = async (items) => {
    const user = JSON.parse(localStorage.getItem('loggedInUserInfo'));

    const deletIds = items?.map((item) => ({
      logId: item?._id,
    }));
    await dispatch(submitAction.deleteMultiDownloadLogs(deletIds, t));

    const fetchParams = {
      email: user?.email,
      reqId,
    };
    getMultiSubmissionLogList(fetchParams);
  };

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container">
          <span className="title">{t('MULTI_SUBMIT_DOWNLOAD_LOGS.DOWNLOAD_LOG')}</span>
        </div>
        {backButtonShow && (
          <Link className="cursor-pointer text-dark text-decoration-none btn btn-white btn-back-lib ml-auto" to="/submit-download-history">
            {t('MULTI_SUBMIT_DOWNLOAD_LOGS.BACK')}
          </Link>
        )}
      </div>

      <div>
        {loading ? (
          <Loader />
        ) : (
          <Container fluid>
            <Row>
              {submitLogdata?.map((item, i) => (
                <MultiSubmitLogCard
                  item={item}
                  key={item}
                  index={i}
                  activeInactiveSubmitLog
                  downloadFile={downloadFile}
                  deleteFiles={deleteFiles}
                  highLightId={reqId || null}
                  fromDownload
                />
              ))}
            </Row>
            {submitLogdata?.length === 0 && (
              <div>
                <p className="mt-3 text-center">{t('MULTI_SUBMIT_DOWNLOAD_LOGS.LOG AVAILBLE')}</p>
              </div>
            )}
          </Container>
        )}
      </div>
    </>
  );
}

export default MultiDownloadLogs;
